import React from "react";

import { ToolbarItem } from "../ToolbarItem";
import { hasEntity } from "../../utils";

export const CustomAction = (props) => {
    const { label, icon, editorState, entityType, setEditingEntity, disabled } = props;
    return (
        <ToolbarItem
            label={label}
            icon={icon}
            active={hasEntity(editorState, entityType)}
            onToggle={() => setEditingEntity(entityType)}
            disabled={disabled}
        />
    );
};
